import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageMotherG.module.scss";

function PageMotherG() {
  const getImgSet = useImgSet();

  const item01 = getImgSet("item__01__p19", "png", [s.item, s.item__01]);
  const pointer = getImgSet("pointer__mother", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__02", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>{imgA}</div>
      <div className={s.inner}>{item01}</div>
      <div className={s.aside_right}>
        <Link to="/mother/" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageMotherG);
